import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2268314c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2268314c')) {
      api.createRecord('2268314c', component.options)
    } else {
      api.reload('2268314c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2268314c", function () {
      api.rerender('2268314c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/power-plant-data/edit.vue"
export default component.exports